import { render, staticRenderFns } from "./AnswerFunctionTable.vue?vue&type=template&id=19c3e334"
import script from "./AnswerFunctionTable.vue?vue&type=script&lang=js"
export * from "./AnswerFunctionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports